import dayjs from 'dayjs';
import { createStore } from 'zustand';
import { OrderDTO, TimesheetColumnFilters, TimesheetTopLevelFilters } from '../api/types';
import { DEFAULT_TIMESHEETS_FILTERS, DEFAULT_TIMESHEETS_SORTING } from '../const';

type State = {
  topLevelFilters: TimesheetTopLevelFilters;
  columnFilters: TimesheetColumnFilters;
  orders: OrderDTO[];
  selectedRange: [dayjs.Dayjs, dayjs.Dayjs];
};

type Actions = {
  setSelectedRange: (range: [dayjs.Dayjs, dayjs.Dayjs]) => void;
  setTopLevelFilters: (filters: TimesheetTopLevelFilters) => void;
  setColumnFilters: (filters: TimesheetColumnFilters) => void;
  setOrders: (orders: OrderDTO[]) => void;
  resetAll: () => void;
};

type TimesheetsState = State & Actions;

const initialState: State = {
  topLevelFilters: DEFAULT_TIMESHEETS_FILTERS,
  columnFilters: {},
  orders: DEFAULT_TIMESHEETS_SORTING,
  selectedRange: [dayjs().subtract(5, 'month'), dayjs()],
};
const timesheetsStore = createStore<TimesheetsState>((set) => ({
  ...initialState,
  setSelectedRange: (range) => set({ selectedRange: range }),
  setTopLevelFilters: (newFilters) =>
    set((state) => ({ topLevelFilters: { ...state.topLevelFilters, ...newFilters } })),
  setColumnFilters: (newFilters) => set({ columnFilters: newFilters }),
  setOrders: (orders) => set({ orders }),
  resetAll: () => set(initialState),
}));

export default timesheetsStore;
